export default (context, data) => {
    context.musics = context.musics.map((item, index) => {
        if(data.index === index) {
            let arr = item
            arr.play = true
            let audio = document.getElementById(`${data.id}`)
            audio.play()
            return arr
        } else {
            let arr = item
            arr.play = false
            let audio = document.getElementById(`${item.id}`)
            audio.pause()
            audio.currentTime = 0
            return arr

        }
    })
}